// THIS CODE WAS AUTO-GENERATED from '/packages/icon/src/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...props}>
    <path d="M6.79 3.47v9.72h4.78s-.06 2.9-3.56 5.51l2.89 2.77s6.31-3.56 6.31-10.97V3.47H6.8Z" />
  </BaseIcon>
)
